module.exports = "/_next/static/images/help-c7be7482d079c9ca9eba48b049310f0f.jpg";